import React from 'react'
import SchoolSkillBox from '../../features/school/SchoolSkillBox'

const SchoolSkillBoxPage = () => {
    return (
        <SchoolSkillBox />
    )
}

export default SchoolSkillBoxPage
